"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3373],{

/***/ 3373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InstitutionalPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Internals/NewsItem/styles.tsx
var styles = __webpack_require__(6561);
// EXTERNAL MODULE: ./src/components/Internals/HeaderImage/index.tsx
var HeaderImage = __webpack_require__(8964);
// EXTERNAL MODULE: ./src/components/Layout/Chip/index.tsx
var Chip = __webpack_require__(2384);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Institutional/AdvertiseHere/styles.tsx





var variants = {
    AdvertiseHereMainContainer: {
        singleColumn: {
            true: "[grid-column:1]",
            false: ""
        }
    },
    AdvertiseHerePageTextContainer: {
        hasNoSideContent: {
            true: "first-of-type:[&>div]:aspect-[initial]",
            false: ""
        }
    }
};
var AdvertiseHereMainContainer = function(_param) {
    var children = _param.children, _singleColumn = _param.singleColumn, singleColumn = _singleColumn === void 0 ? undefined : _singleColumn, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "singleColumn"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,className/* default */.Z)("font-primary [grid-column-start:1] [grid-column:1] desktop:[grid-column:initial]", singleColumn != null && variants.AdvertiseHereMainContainer.singleColumn[singleColumn.toString()])
    }, rest), {
        children: children
    }));
};
var AdvertiseHerePageTextContainer = function(_param) {
    var children = _param.children, _hasNoSideContent = _param.hasNoSideContent, hasNoSideContent = _hasNoSideContent === void 0 ? undefined : _hasNoSideContent, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "hasNoSideContent"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,className/* default */.Z)("w-full pr-0 text-lg tablet:pr-[initial] [&>div>div]:mb-16 first-of-type:[&>div]:aspect-[540/306] [&>h2]:mb-8 [&>h2]:text-2xl [&>h2]:font-medium [&>p]:mb-8 [&>p]:text-lg [&>ul>li]:list-none before:[&>ul>li]:mr-2 before:[&>ul>li]:content-[•]", hasNoSideContent != null && variants.AdvertiseHerePageTextContainer.hasNoSideContent[hasNoSideContent.toString()])
    }, rest), {
        children: children
    }));
};
var AdvertiseHereChipContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "max-w-80 rounded-[60px] [&>div>div>span]:text-base [&>div>div>span]:leading-4 [&>div>div]:[margin-inline:auto] [&>div]:flex [&>div]:px-8 [&>div]:py-6 [&>span]:m-0"
    }, rest), {
        children: children
    }));
};
var AdvertiseHereGridItem = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex w-full flex-col items-center justify-center rounded bg-mglGray50 px-0 py-4 shadow-[0px_10px_35px_-10px_rgba(64,_59,_75,_0.1)] [&>svg]:text-2xl"
    }, rest), {
        children: children
    }));
};
var AdvertiseHereMainText = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "mb-1 mt-2 text-center text-lg font-medium text-mglGray900"
    }, rest), {
        children: children
    }));
};
var AdvertiseHereSubText = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "text-center text-xs font-light text-mglGray900"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AdvertiseHere_styles = ({});

// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Institutional/AdvertiseHere/index.tsx















var FormModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2939).then(__webpack_require__.bind(__webpack_require__, 2939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2939)
            ];
        }
    }
});
var MidiaKit = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8319).then(__webpack_require__.bind(__webpack_require__, 8319));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8319)
            ];
        }
    }
});
var icons = {
    atividade: {
        "Pageviews/m\xeas": "mdi:file-document-outline",
        "Visitas Totais/m\xeas": "mdi:eye",
        "Usu\xe1rio \xdanicos/m\xeas": "mdi:person-outline",
        Inscritos: "mdi:thumb-up"
    },
    publicoAlvo: {
        "P\xfablico Alvo": "mdi:radio-tower",
        Masculino: "mdi:gender-male",
        Feminino: "mdi:gender-female"
    },
    redesSociais: {
        "Inscritos Facebook": "mdi:facebook",
        "Inscritos Tik Tok": "akar-icons:tiktok-fill",
        "Inscritos Instagram": "mdi:instagram",
        "Inscritos Twitter": "mdi:twitter",
        "Inscritos Linkedin": "mdi:linkedin"
    }
};
function AdvertiseHere(param) {
    var text = param.text, headerImg = param.headerImg, estatisticas = param.estatisticas, midiaKit = param.midiaKit, parceiros = param.parceiros;
    var ref = (0,react.useState)(false), isFormModalOpen = ref[0], setIsFormModalOpen = ref[1];
    var ref1 = (0,react.useState)(""), utmCampaign = ref1[0], setUtmCampaign = ref1[1];
    var router = (0,next_router.useRouter)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref2[0];
    (0,react.useEffect)(function() {
        if (router === null || router === void 0 ? void 0 : router.query.utm_campaign) setUtmCampaign(router === null || router === void 0 ? void 0 : router.query.utm_campaign);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
                isOnHeader: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* GridInternal */.J, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHereMainContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHerePageTextContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImage/* default */.Z, {
                                            url: headerImg.url,
                                            caption: "",
                                            srcset: headerImg.srcset,
                                            isHeader: "internal"
                                        }),
                                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MidiaKit, {
                                            midiaKit: midiaKit,
                                            setIsOpen: setIsFormModalOpen
                                        }),
                                        (0,html_react_parser/* default */.ZP)(text),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereChipContainer, {
                                            className: "mb-16 hover:[&>div]:border-mglGray900 hover:[&>div]:bg-mglGray900 hover:[&>div]:text-mglGray50",
                                            onClick: function() {
                                                return setIsFormModalOpen(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                title: "deixar a sua mensagem",
                                                texto: "deixar a sua mensagem",
                                                chipSize: "large",
                                                borderColor: "black",
                                                color: "black",
                                                backgroundColor: "white",
                                                posIcon: "chevron-right"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb-12 text-2xl font-medium text-mglGray900",
                                    children: "Engajamento"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "flex flex-col gap-2 bg-mglGray50 pb-12 pt-8 desktop:pt-[initial]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grid grid-cols-2 gap-3 desktop:grid-cols-4 [&>div]:[@media_only_screen_and_(max-width:426px)]:[grid-column:span_2]",
                                            children: estatisticas.atividade.map(function(activity) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHereGridItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            icon: icons.atividade[activity.label],
                                                            color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereMainText, {
                                                            children: activity.quantidade
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereSubText, {
                                                            children: activity.label
                                                        })
                                                    ]
                                                }, activity.label);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "[&>div]:bg-gray-50 grid grid-cols-2 gap-4 shadow-[0px_10px_35px_-10px_rgba(64,_59,_75,_0.1)] phone:gap-3 desktop:grid-cols-3 [&>div]:[@media_only_screen_and_(max-width:767px)]:[grid-column:span_2] first:[&>div]:[@media_only_screen_and_(max-width:992px)]:[grid-column:span_2]",
                                            children: estatisticas.publicoAlvo.map(function(audience) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHereGridItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            icon: icons.publicoAlvo[audience.label],
                                                            color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereMainText, {
                                                            children: audience.quantidade
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereSubText, {
                                                            children: audience.label
                                                        })
                                                    ]
                                                }, audience.label);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grid grid-cols-2 gap-3 desktop:grid-cols-5 [&>div]:[@media_only_screen_and_(max-width:426px)]:[grid-column:span_2] first:[&>div]:[@media_only_screen_and_(max-width:992px)]:[grid-column:span_2]",
                                            children: estatisticas.redesSociais.map(function(socialNetwork) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHereGridItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            icon: icons.redesSociais[socialNetwork.label],
                                                            color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereMainText, {
                                                            children: socialNetwork.quantidade
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereSubText, {
                                                            children: socialNetwork.label
                                                        })
                                                    ]
                                                }, socialNetwork.label);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "px-0 py-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-12 text-2xl font-medium text-mglGray900",
                                            children: "Confira alguns de nossos anunciantes e parceiros"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grid grid-cols-2 gap-3 desktop:grid-cols-4 [@media_only_screen_and_(max-width:426px)]:[&>div]:[grid-column:span_2]",
                                            children: parceiros.map(function(partner) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "rounded border border-solid border-mglGray200",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: partner.url,
                                                        blurhash: partner.blurhash
                                                    })
                                                }, partner.url);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MidiaKit, {
                            midiaKit: midiaKit,
                            setIsOpen: setIsFormModalOpen
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal, {
                isOpen: isFormModalOpen,
                setIsOpen: setIsFormModalOpen,
                utmCampaign: utmCampaign
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: "https://koi-3QNGUF4MW0.marketingautomation.services/client/noform.js?ver=1.24"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: "var _ss = _ss || []; _ss.push(['_setDomain', 'https://koi-3QNGUF4MW0.marketingautomation.services/net']); _ss.push(['_setAccount', 'KOI-42FV649XZC']); _ss.push(['_trackPageView']); (function() { var ss = document.createElement('script'); ss.type = 'text/javascript'; ss.async = true; ss.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'koi-3QNGUF4MW0.marketingautomation.services/client/ss.js?ver=1.1.1'; var scr = document.getElementsByTagName('script')[0]; scr.parentNode.insertBefore(ss, scr); })();"
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(7517);
// EXTERNAL MODULE: ./src/components/Layout/InternalTitle/index.tsx
var InternalTitle = __webpack_require__(2434);
;// CONCATENATED MODULE: ./src/components/Institutional/InstitutionalHeader/index.tsx




function InstitutionalHeader(param) {
    var breadcrumb = param.breadcrumb, titulo = param.titulo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
        isOnHeader: true,
        hasBreadcrumb: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "flex flex-col justify-between tablet:flex-row tablet:items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                    breadcrumbList: breadcrumb
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalTitle/* default */.Z, {
                title: titulo
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Internals/NewsContent/styles.tsx
var NewsContent_styles = __webpack_require__(2657);
// EXTERNAL MODULE: ./src/components/Layout/Title/index.tsx
var Title = __webpack_require__(9879);
;// CONCATENATED MODULE: ./src/components/Institutional/About/PinnedMap/index.tsx

function PinnedMap() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "map-wrap",
            className: "hidden w-full md:flex [&_div]:h-full [&_div]:min-h-[300px] [&_div]:w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "map"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./src/components/Layout/Modal/index.tsx
var Modal = __webpack_require__(4775);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/components/Institutional/AdvertiseHere/FormModal/styles.tsx + 1 modules
var FormModal_styles = __webpack_require__(1229);
;// CONCATENATED MODULE: ./src/components/Institutional/About/ContactForm/index.tsx
/* eslint-disable dot-notation */ 












var subjectSelectOptions = [
    "D\xfavidas",
    "Elogios, cr\xedticas e sugest\xf5es",
    "Erros no site",
    "Privacidade",
    "Outros assuntos",
    "Sugest\xf5es de pautas"
];
var whereSelectOptions = [
    "Amigo",
    "Facebook",
    "Instagram",
    "Twitter",
    "Telas Corporativas",
    "TV a Cabo",
    "Outros sites",
    "Busca no Google",
    "Colunistas Canaltech",
    "Publicidade",
    "Outros", 
];
var initialValues = {
    nome: "",
    email: "",
    telefone: "",
    comoConheceu: "",
    assunto: "",
    mensagem: ""
};
var feedbackMessage = {
    title: {
        success: "Dados enviados com sucesso",
        error: "Encontramos um problema ao enviar os seus dados"
    },
    body: {
        success: "Agradecemos pela sua mensagem!",
        error: "Por favor, tente novamente mais tarde."
    }
};
function ContactForm(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var reducer = function reducer(state, action) {
        if (action.type === "change") {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, action.fieldName, action.value));
        }
        if (action.type === "reset") {
            Object.keys(state).map(function(key) {
                return (0,_define_property/* default */.Z)({}, key, "");
            });
        }
        return state;
    };
    var ref = (0,react.useState)(false), isWhereSelectMenuOpen = ref[0], setIsWhereSelectMenuOpen = ref[1];
    var ref1 = (0,react.useState)(false), isSubjectSelectMenuOpen = ref1[0], setIsSubjectSelectMenuOpen = ref1[1];
    var ref2 = (0,react.useReducer)(reducer, initialValues), state = ref2[0], dispatch = ref2[1];
    var nome = state.nome, email = state.email, telefone = state.telefone, comoConheceu = state.comoConheceu, mensagem = state.mensagem, assunto = state.assunto;
    var ref3 = (0,react.useState)({
        hasSubmitted: false
    }), submissionStatus = ref3[0], setSubmissionStatus = ref3[1];
    var handleFormChange = function(event) {
        var _target = event.target, name = _target.name, value = _target.value;
        dispatch({
            type: "change",
            fieldName: name,
            value: value
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                data = new FormData();
                Object.keys(state).map(function(key) {
                    return data.append(key, state[key]);
                });
                axios_default().post("/contato.json", data).then(function(res) {
                    if (res.data.code === 200) {
                        setSubmissionStatus({
                            hasSubmitted: true,
                            status: "success"
                        });
                    } else {
                        setSubmissionStatus({
                            hasSubmitted: true,
                            status: "error"
                        });
                    }
                }).catch(function() {
                    setSubmissionStatus({
                        hasSubmitted: true,
                        status: "error"
                    });
                });
                dispatch({
                    type: "reset"
                });
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var phoneMask = function(phone) {
        var maskedNumber = phone.replace(/\D/g, "").replace(/^(\d{2})(\d)/g, "($1) $2").replace(/(\d)(\d{4})$/, "$1-$2");
        dispatch({
            type: "change",
            fieldName: "telefone",
            value: maskedNumber
        });
        return maskedNumber;
    };
    var isFormValid = function() {
        return !!nome && !!email && !!telefone && !!comoConheceu && !!assunto;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        children: !submissionStatus.hasSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFormComponent */._p, {
            id: "form-contato",
            encType: "multipart/form-data",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldBox */.Z3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldName */.Av, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:message-text-outline",
                                    color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalFieldLabel */.LW, {
                                    htmlFor: "comoConheceu",
                                    children: "selecione um assunto"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSelect */.uR, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSelectMenu */.cc, {
                                    "data-testid": "assunto",
                                    isOpen: isSubjectSelectMenuOpen,
                                    onClick: function() {
                                        return setIsSubjectSelectMenuOpen(!isSubjectSelectMenuOpen);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSelectText */.nH, {
                                        children: [
                                            assunto,
                                            "\xa0"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSelectOptions */.Wg, {
                                    isOpen: isSubjectSelectMenuOpen,
                                    children: subjectSelectOptions.map(function(option) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSelectLabel */.zm, {
                                            htmlFor: option,
                                            onClick: function() {
                                                dispatch({
                                                    type: "change",
                                                    fieldName: "assunto",
                                                    value: option
                                                });
                                                setIsSubjectSelectMenuOpen(false);
                                            },
                                            children: [
                                                option,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSelectInput */.n5, {
                                                    id: option,
                                                    type: "radio",
                                                    name: "assunto",
                                                    value: option
                                                })
                                            ]
                                        }, option);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldBox */.Z3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldName */.Av, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:person-outline",
                                    color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalFieldLabel */.LW, {
                                    htmlFor: "nome",
                                    children: "nome"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalTextInput */.d3, {
                            type: "text",
                            id: "nome",
                            name: "nome",
                            minLength: 2,
                            value: nome,
                            onChange: handleFormChange,
                            onKeyPress: function(event) {
                                return event.key === "Enter" && handleSubmit;
                            },
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldBox */.Z3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldName */.Av, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:email-outline",
                                    color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalFieldLabel */.LW, {
                                    htmlFor: "email",
                                    children: "e-mail"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalTextInput */.d3, {
                            type: "email",
                            id: "email",
                            name: "email",
                            value: email,
                            onChange: handleFormChange,
                            onKeyPress: function(event) {
                                return event.key === "Enter" && handleSubmit;
                            },
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldBox */.Z3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldName */.Av, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:phone-outline",
                                    color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalFieldLabel */.LW, {
                                    htmlFor: "telefone",
                                    children: "telefone"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalTextInput */.d3, {
                            type: "text",
                            id: "telefone",
                            name: "telefone",
                            minLength: 14,
                            maxLength: 15,
                            placeholder: "(00) 0000-0000",
                            onKeyUp: function() {
                                return phoneMask(telefone);
                            },
                            value: telefone,
                            onChange: handleFormChange,
                            onKeyPress: function(event) {
                                return event.key === "Enter" && handleSubmit;
                            },
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldBox */.Z3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldName */.Av, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:map-marker-question",
                                    color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalFieldLabel */.LW, {
                                    htmlFor: "comoConheceu",
                                    children: "onde conheceu o Canaltech?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSelect */.uR, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSelectMenu */.cc, {
                                    "data-testid": "comoConheceu",
                                    isOpen: isWhereSelectMenuOpen,
                                    onClick: function() {
                                        return setIsWhereSelectMenuOpen(!isWhereSelectMenuOpen);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSelectText */.nH, {
                                        children: [
                                            comoConheceu,
                                            "\xa0"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSelectOptions */.Wg, {
                                    isOpen: isWhereSelectMenuOpen,
                                    children: whereSelectOptions.map(function(option) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSelectLabel */.zm, {
                                            htmlFor: option,
                                            onClick: function() {
                                                dispatch({
                                                    type: "change",
                                                    fieldName: "comoConheceu",
                                                    value: option
                                                });
                                                setIsWhereSelectMenuOpen(false);
                                            },
                                            children: [
                                                option,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSelectInput */.n5, {
                                                    id: option,
                                                    type: "radio",
                                                    name: "comoConheceu",
                                                    value: option
                                                })
                                            ]
                                        }, option);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldBox */.Z3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalFieldName */.Av, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:text-box-edit-outline",
                                    color: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalFieldLabel */.LW, {
                                    htmlFor: "mensagem",
                                    children: "mensagem"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalTextArea */.qV, {
                            name: "mensagem",
                            id: "mensagem",
                            value: mensagem,
                            onChange: handleFormChange,
                            onKeyPress: function(event) {
                                return event.key === "Enter" && handleSubmit;
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSubmitButton */.TB, {
                    type: "button",
                    onClick: handleSubmit,
                    disabled: !isFormValid(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        title: "enviar mensagem",
                        texto: "enviar mensagem",
                        chipSize: "large",
                        borderColor: "black",
                        color: "black",
                        backgroundColor: "white",
                        posIcon: "chevron-right"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormModal_styles/* FormModalSuccessMessageContainer */.Mm, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSuccessMessage */.zN, {
                    isTitle: true,
                    children: feedbackMessage["title"][submissionStatus.status]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal_styles/* FormModalSuccessMessage */.zN, {
                    children: feedbackMessage["body"][submissionStatus.status]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Institutional/About/ContactBox/index.tsx






function ContactBox() {
    var ref = (0,react.useState)(false), isFormModalOpen = ref[0], setIsFormModalOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex flex-col gap-8 bg-mglBlue400 tablet:flex-row tablet:gap-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col gap-6 text-mglGray50",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Fale com a gente"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Voc\xea tem algo a nos dizer? Clique no bot\xe3o abaixo e preencha o formul\xe1rio."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Entraremos em contato assim que poss\xedvel."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            marginBottom: "8px"
                                        },
                                        children: "E-mail para sugest\xf5es de pauta:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                icon: "mdi:email-outline"
                                            }),
                                            " redacao@canaltech.com.br"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        style: {
                                            marginBottom: "8px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        style: {
                                            fontSize: "0.875rem"
                                        },
                                        children: "Infelizmente, nem sempre conseguimos atender a todas as solicita\xe7\xf5es, mas nossa equipe est\xe1 sempre a postos para ajudar."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                chipSize: "medium",
                                texto: "formul\xe1rio de contato",
                                posIcon: "chevron-right",
                                borderColor: "white",
                                title: "Abrir formul\xe1rio de contato",
                                color: "white",
                                hover: "black",
                                onClick: function() {
                                    return setIsFormModalOpen(true);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedMap, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {
                isOpen: isFormModalOpen,
                setIsOpen: setIsFormModalOpen
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Institutional/Team/MemberListing/index.tsx
/* eslint-disable react/jsx-props-no-spreading */ 






var MemberCard = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var name = param.name, _url = param.url, url = _url === void 0 ? "" : _url, role = param.role, image = param.image;
    var linkProps = {};
    var Tag = url ? "a" : "div";
    if (url) Object.assign(linkProps, {
        href: url,
        ref: ref
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
        className: (0,className/* default */.Z)("flex gap-4", url && "cursor-pointer"),
        title: "".concat(url && "Ver p\xe1gina de ").concat(name),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-20 w-20 [&>figure>div>img]:rounded-half [&>figure>div>canvas]:rounded-half",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image.url,
                    blurhash: image.blurhash,
                    alt: "".concat(name, " - ").concat(role, " no Canaltech"),
                    title: "".concat(name, " - ").concat(role, " no Canaltech")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col content-center justify-center gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-medium text-mglBlue400",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm text-mglGray900",
                        children: role
                    })
                ]
            })
        ]
    }));
});
function MemberListing(param) {
    var members = param.members;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 gap-x-4 gap-y-8 pt-10 tablet:grid-cols-2 desktop:grid-cols-3",
        children: members.map(function(member) {
            return member.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: member.url,
                prefetch: false,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberCard, {
                    name: member.name,
                    role: member.role,
                    image: member.image,
                    url: member.url
                })
            }, member.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberCard, {
                name: member.name,
                role: member.role,
                image: member.image
            }, member.name);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Institutional/InstitutionalContent/index.tsx











function InstitutionalContent(param) {
    var text = param.text, headerImg = param.headerImg, _hasContactForm = param.hasContactForm, hasContactForm = _hasContactForm === void 0 ? false : _hasContactForm, _members = param.members, members = _members === void 0 ? undefined : _members;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
                isOnHeader: true,
                paddingOnBottom: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* GridInternal */.J, {
                    singleColumn: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereMainContainer, {
                        singleColumn: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHerePageTextContainer, {
                            hasNoSideContent: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImage/* default */.Z, {
                                    url: headerImg.url,
                                    caption: "",
                                    srcset: headerImg.srcset,
                                    isHeader: "full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsContent_styles/* DivContentNews */._7, {
                                    children: (0,html_react_parser/* default */.ZP)(text)
                                })
                            ]
                        })
                    })
                })
            }),
            hasContactForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
                backgroundColor: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400,
                paddingOnBottom: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactBox, {})
            }),
            hasContactForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                backgroundColor: designSystemColors/* mglGray.mglGray100 */.Ce.mglGray100,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        texto: "Conhe\xe7a Nossa Equipe",
                        color: "black",
                        noPadding: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberListing, {
                        members: members.map(function(member) {
                            return {
                                name: member.nome,
                                role: member.cargo,
                                image: member.imagem,
                                url: member.url
                            };
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/Accordion/index.tsx
var Accordion = __webpack_require__(4934);
;// CONCATENATED MODULE: ./src/components/Institutional/SpeedTest/index.tsx






function SpeedTestContent(param) {
    var accordion = param.accordion, headerImg = param.headerImg;
    var nPerfMinifiedScript = '<script>var url_path="https://ws.nperf.com";document.write(\'<iframe id="nPerfSpeedTest" src="\'+url_path+\'/partner/frame?l=c5fd36a3-299a-4050-a62c-b2ee26e4f843"  width="0" height="0" frameborder="0" scrolling="no" style="overflow: hidden; display: block; margin: 0px; padding: 0px; max-width: 600px; height: 400px; width: 100%" allow="geolocation" referrerpolicy="unsafe-url"></iframe>\'),window.addEventListener("message",(function(t){if("https://ws.nperf.com"==t.origin||"https://ws-cdn.nperf.com"==t.origin||"http://ws-nossl.nperf.com"==t.origin){try{"nPerfReady"==t.data.action&&nPerfReady()}catch(t){}try{"nPerfError"==t.data.action&&nPerfError(t.data.type)}catch(t){}try{"nPerfTestStarted"==t.data.action&&nPerfTestStarted()}catch(t){}try{"nPerfTestStarted"==t.data.action&&nPerfTestStartedOrRestarted(t.data.restart)}catch(t){}try{"nPerfTestCompleted"==t.data.action&&nPerfTestCompletedObj(t.data)}catch(t){}try{"nPerfTestCompleted"==t.data.action&&nPerfTestCompleted(t.data.id,t.data.isp,t.data.download_avg,t.data.download_peak,t.data.upload_avg,t.data.upload_peak,t.data.latency,t.data.latency_avg,t.data.latency_jitter,t.data.pool_id)}catch(t){}try{"nPerfGetLastResult"===t.data.action&&nPerfGetLastResult(t.data.lastResult)}catch(t){}try{if("nPerfGetLastResult"===t.data.action){var a={action:"nPerfTestCompleted",id:t.data.lastResult.resultId,isp:t.data.lastResult.networkStart.ipV4.ispName||t.data.lastResult.networkStart.ipV6.ispName,download_avg:Math.round(t.data.lastResult.speed.download.averageExcludingSlowStart/1e3),download_peak:Math.round(t.data.lastResult.speed.download.peak/1e3),download_packetloss:t.data.lastResult.speed.download.tcpPacketLoss,upload_avg:Math.round(t.data.lastResult.speed.upload.averageExcludingSlowStart/1e3),upload_peak:Math.round(t.data.lastResult.speed.upload.peak/1e3),latency:t.data.lastResult.speed.latency.minimum,latency_avg:t.data.lastResult.speed.latency.average,latency_jitter:t.data.lastResult.speed.latency.jitter,pool_id:t.data.lastResult.speed.pool.poolId,locationType:t.data.lastResult.locationStart.type,locationAccuracy:t.data.lastResult.locationStart.accuracy,locationLat:t.data.lastResult.locationStart.latitude,locationLng:t.data.lastResult.locationStart.longitude,locationCountryIso3166:t.data.lastResult.locationGeocoding.country,locationAal1:t.data.lastResult.locationGeocoding.aal1,locationAal2:t.data.lastResult.locationGeocoding.aal2,locationLocality:t.data.lastResult.locationGeocoding.locality,locationFullAddress:t.data.lastResult.locationGeocoding.fullAddress};nPerfTestCompletedObj(a)}}catch(t){}try{"nPerfGetLastResult"===t.data.action&&nPerfTestCompleted(t.data.lastResult.resultId,t.data.lastResult.networkStart.ipV4.ispName||t.data.lastResult.networkStart.ipV6.ispName,Math.round(t.data.lastResult.speed.download.averageExcludingSlowStart/1e3),Math.round(t.data.lastResult.speed.download.peak/1e3),Math.round(t.data.lastResult.speed.upload.averageExcludingSlowStart/1e3),Math.round(t.data.lastResult.speed.upload.peak/1e3),t.data.lastResult.speed.latency.minimum,t.data.lastResult.speed.latency.average,t.data.lastResult.speed.latency.jitter,t.data.lastResult.speed.pool.poolId)}catch(t){}try{"nPerfTestShare"==t.data.action&&nPerfTestShare(t.data)}catch(t){}try{"nPerfResponsiveSwitch"==t.data.action&&("smart"==t.data.mode?document.getElementById("nPerfSpeedTest").style.height="500px":document.getElementById("nPerfSpeedTest").style.height="400px")}catch(t){}try{"nPerfGetRealTimeUpdate"===t.data.action&&(delete t.data.action,nPerfGetRealTimeUpdate(t.data))}catch(t){}}}),!1),document.getElementById("nPerfSpeedTest").offsetWidth>0&&document.getElementById("nPerfSpeedTest").offsetWidth<600&&(document.getElementById("nPerfSpeedTest").style.height="500px");</script>';
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
        isOnHeader: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: "mt-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHereMainContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvertiseHerePageTextContainer, {
                    hasNoSideContent: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImage/* default */.Z, {
                            url: headerImg.url,
                            caption: "",
                            srcset: headerImg.srcset,
                            isHeader: "full"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "bg-mglGray50 px-0 py-10",
                            id: "speed",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                id: "nPerfSpeedTest",
                                title: "Teste de velocidade",
                                loading: "lazy",
                                width: "0",
                                height: "0",
                                frameBorder: "0",
                                scrolling: "no",
                                style: {
                                    overflow: "hidden",
                                    display: "block",
                                    margin: "0px auto",
                                    padding: "0px",
                                    maxWidth: "600px",
                                    height: "400px",
                                    width: "100%"
                                },
                                allow: "geolocation",
                                referrerPolicy: "unsafe-url",
                                srcDoc: nPerfMinifiedScript
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "bg-mglGray50 px-0 py-10",
                            id: "coverage-map",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                id: "nPerfSpeedTest",
                                title: "Mapa de cobertura",
                                loading: "lazy",
                                src: "https://ws.nperf.com/partner/map?l=68480cf9-e851-44e7-800f-dd83d633ea31&ll=default&lg=default&zoom=default&locale=pt",
                                height: "400",
                                frameBorder: "0",
                                scrolling: "no",
                                style: {
                                    overflow: "hidden",
                                    display: "block",
                                    margin: "0 auto",
                                    padding: 0,
                                    width: "100%",
                                    maxWidth: "600px"
                                },
                                allow: "geolocation",
                                referrerPolicy: "origin-when-cross-origin",
                                allowFullScreen: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "pb-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsContent_styles/* DivContentNews */._7, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                    items: accordion.map(function(item) {
                                        return {
                                            title: item.titulo,
                                            content: item.conteudo
                                        };
                                    }),
                                    openItem: accordion[0].titulo
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Institutional/Footer/index.tsx


function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
        paddingOnBottom: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "w-full text-balance text-center text-sm",
            children: [
                "UNILOGIC Media Group LTDA.- CNPJ 09.081.439/0001-60 | Endere\xe7o: Rua Maria Prestes Maia, 300, Vila Guilherme, S\xe3o Paulo, Estado de S\xe3o Paulo CEP: 02047-000. Canaltech - Todos os direitos reservados. Endere\xe7o eletr\xf4nico:",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://canaltech.com.br/",
                    className: " text-mglBlue400 no-underline",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "canaltech.com.br"
                }),
                " ",
                "| Fale conosco:",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://canaltech.com.br/sobre/",
                    className: "text-mglBlue400 no-underline",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "canaltech.com.br/sobre/"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Institutional/InstitutionalPage/index.tsx






function InstitutionalPage(param) {
    var text = param.text, title = param.title, headerImg = param.headerImg, type = param.type, breadcrumbs = param.breadcrumbs, advertiseData = param.advertiseData, accordion = param.accordion, members = param.members;
    var RenderedInstitutionalPage = function() {
        switch(type){
            case "anuncie":
                return advertiseData && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertiseHere, {
                    text: text,
                    headerImg: headerImg,
                    estatisticas: advertiseData.estatisticas,
                    midiaKit: advertiseData.midiaKit,
                    parceiros: advertiseData.parceiros
                });
            case "integridade":
            case "privacidade":
            case "sobre":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstitutionalContent, {
                    text: text,
                    headerImg: headerImg,
                    hasContactForm: type === "sobre",
                    members: members
                });
            case "velocidade":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeedTestContent, {
                    accordion: accordion,
                    headerImg: headerImg
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-[50px] font-primary font-light desktop:mb-[90px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstitutionalHeader, {
                breadcrumb: breadcrumbs,
                titulo: title
            }),
            RenderedInstitutionalPage(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}


/***/ }),

/***/ 6561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ GridInternal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    GridInternal: {
        singleColumn: {
            true: "singleColumn [&.singleColumn]:desktop:grid-cols-1",
            false: ""
        }
    }
};
var GridInternal = function(_param) {
    var children = _param.children, singleColumn = _param.singleColumn, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleColumn"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("mt-4 grid grid-cols-1 grid-rows-1 gap-0 desktop:grid-cols-[minmax(0,1fr)_336px] desktop:gap-8", singleColumn != undefined && variants.GridInternal.singleColumn[singleColumn.toString()])
    }, rest), {
        children: children
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    GridInternal: GridInternal
});


/***/ }),

/***/ 4934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5935);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _components_Internals_NewsContent_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6008);







function Accordion(param) {
    var items = param.items, openItem = param.openItem, blueTheme = param.blueTheme;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(openItem || ""), selected = ref[0], setSelected = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("mx-4 my-0 list-none rounded bg-transparent px-8 tablet:mx-auto tablet:my-auto  tablet:mt-4", blueTheme && "  bg-white"),
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionItem, {
                content: item.content,
                isOpen: item.title === selected,
                title: item.title,
                setSelected: setSelected,
                blueTheme: blueTheme
            }, item.title);
        })
    });
}
function AccordionItem(param) {
    var isOpen = param.isOpen, title = param.title, content = param.content, setSelected = param.setSelected, blueTheme = param.blueTheme;
    var isOpenProps = {
        Container: "pb-6",
        Button: "isOpenAccordion mb-4 [&>svg]:rotate-180"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("border-0 border-b-[0.5px] border-solid border-b-mglGray200 bg-mglGray50 py-8", blueTheme && "  bg-white", isOpen && isOpenProps.Container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex w-full appearance-none items-center justify-between gap-8 border-none bg-mglGray50 [&>h2]:w-full [&>h2]:text-left [&>h2]:text-lg [&>svg]:transition-all [&>svg]:duration-300 [&>svg]:ease-ease", isOpen && isOpenProps.Button, blueTheme && "bg-white", "transition-all duration-[600ms]"),
                onClick: function() {
                    return setSelected(isOpen ? "" : title);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: title
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        icon: "mdi:chevron-down",
                        width: 18,
                        height: 18,
                        color: blueTheme ? _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglBlue.mglBlue400 */ .Db.mglBlue400 : _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray900 */ .Ce.mglGray900
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Internals_NewsContent_styles__WEBPACK_IMPORTED_MODULE_3__/* .DivContentNews */ ._7, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("m-0 h-auto max-h-0 w-full overflow-hidden text-mglGray900 opacity-0 transition-all duration-[600ms] first:mt-2", isOpen && "max-h-screen opacity-100"),
                children: typeof content === "object" ? content : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(content)
            })
        ]
    });
}


/***/ }),

/***/ 2434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InternalTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function InternalTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-2xl font-medium text-mglGray900 tablet:text-4xl",
        children: title
    });
}


/***/ }),

/***/ 4775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _hooks_useOutsideClickRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6425);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6008);




function Modal(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, children = param.children, iconOutsideBox = param.iconOutsideBox, noPadding = param.noPadding, limitHeight = param.limitHeight;
    var variants = {
        ModalContainer: {
            isOpen: {
                true: "opacity-100 z-[9999]",
                false: "opacity-0 z-[-1]"
            }
        },
        ModalBox: {
            iconOutsideBox: {
                true: "p-0 w-[initial]",
                false: ""
            },
            noPadding: {
                true: "p-0",
                false: ""
            },
            limitHeight: {
                true: "tablet:h-[initial] tablet:overflow-y-[initial] h-full overflow-y-auto",
                false: ""
            }
        },
        ModalCloseIcon: {
            iconOutsideBox: {
                true: "-top-12 right-0 text-mglGray50",
                false: ""
            }
        }
    };
    var modalRef = (0,_hooks_useOutsideClickRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        setIsOpen: setIsOpen
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("fixed left-0 top-0 flex h-full w-full items-center justify-center overflow-auto bg-black/90 transition-all duration-300 ease-ease [&>svg]:cursor-pointer [&>svg]:text-2xl", variants.ModalContainer.isOpen[isOpen.toString()]),
        role: "dialog",
        "aria-modal": isOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative h-full max-h-full min-h-[336px] w-full max-w-[760px] overflow-y-auto rounded-none bg-mglGray50 pb-8 pr-0 pt-16 tablet:max-h-[90%] tablet:rounded", iconOutsideBox != undefined && variants.ModalBox.iconOutsideBox[iconOutsideBox.toString()], noPadding != undefined && variants.ModalBox.noPadding[noPadding.toString()], limitHeight != undefined && variants.ModalBox.limitHeight[limitHeight.toString()]),
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("absolute right-4 top-4 cursor-pointer text-lg text-black/40", iconOutsideBox != undefined && variants.ModalCloseIcon.iconOutsideBox[iconOutsideBox.toString()]),
                    onClick: function() {
                        return setIsOpen(false);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        icon: "mdi:close"
                    })
                }),
                children
            ]
        })
    });
}


/***/ })

}]);